<script>
import {
    BFormGroup, BFormInput, BRow, BCol,
} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup, BFormInput, BRow, BCol,
    },
    props: {
        location: {
            type: Object,
            default() {
                return {
                    address: null,
                    city: null,
                    zip: null,
                    coordinates: {
                        latitude: null,
                        longitude: null
                    },
                    unlocode: null
                };
            }
        }
    },
    data() {
        return {
            address: this.location.address,
            city: this.location.city,
            zip: this.location.zip,
            coordinates: {
                latitude: this.location.coordinates.latitude,
                longitude: this.location.coordinates.longitude
            },
            unlocode: this.location.unlocode,
        }
    },
    methods: {
        emit() {
            this.$emit('input', {
                address: this.address,
                city: this.city,
                zip: this.zip,
                coordinates: this.coordinates,
                unlocode: this.unlocode,
            });
        },
        onLatitudeChange() {
            this.coordinates.latitude = this.coordinates.latitude ? parseFloat(this.coordinates.latitude) : null;
            this.emit();
        },
        onLongitudeChange() {
            this.coordinates.longitude = this.coordinates.longitude ? parseFloat(this.coordinates.longitude) : null;
            this.emit();
        }
    },
    watch: {
        location() {
            this.address = this.location.address;
            this.city = this.location.city;
            this.zip = this.location.zip;
            this.coordinates = {
                latitude: this.location.coordinates.latitude,
                longitude: this.location.coordinates.longitude
            };
            this.unlocode = this.location.unlocode;
        }
    }
}
</script>

<template>
    <div>
        <b-row>
            <b-col>
                <b-form-group
                    :label="$t('Component(Label):address')"
                    label-for="address"
                >
                    <b-form-input
                        id="address"
                        v-model="address"
                        @input="emit"
                        :placeholder="$t('Component(Label):address')"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="8" lg="8">
                <b-form-group
                    :label="$t('Component(Label):city')"
                    label-for="city"
                >
                    <b-form-input
                        id="city"
                        v-model="city"
                        @input="emit"
                        :placeholder="$t('Component(Label):city')"
                    />
                </b-form-group>
            </b-col>
            <b-col md="4" lg="4">
                <b-form-group
                    :label="$t('Component(Label):zip')"
                    label-for="zip"
                >
                    <b-form-input
                        id="zip"
                        v-model="zip"
                        @input="emit"
                        :placeholder="$t('Component(Label):zip')"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6" lg="6">
                <b-form-group
                    :label="$t('Component(Label):latitude')"
                    label-for="latitude"
                >
                    <b-form-input
                        id="latitude"
                        v-model="coordinates.latitude"
                        type="number"
                        @input="onLatitudeChange"
                        :placeholder="$t('Component(Label):latitude')"
                    />
                </b-form-group>
            </b-col>
            <b-col md="6" lg="6">
                <b-form-group
                    :label="$t('Component(Label):longitude')"
                    label-for="longitude"
                >
                    <b-form-input
                        id="longitude"
                        type="number"
                        v-model="coordinates.longitude"
                        @input="onLongitudeChange"
                        :placeholder="$t('Component(Label):longitude')"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group
                    :label="$t('Component(Label):unlocode')"
                    label-for="unlocode"
                >
                    <b-form-input
                        id="unlocode"
                        v-model="unlocode"
                        @input="emit"
                        :placeholder="$t('Component(Label):unlocode')"
                    />
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>
